import React from "react";

function Paragraph(props) {
  return <p className="info">{props.info}</p>;
}
export default Paragraph;
